"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UiGetOperations", {
    enumerable: true,
    get: function() {
        return UiGetOperations;
    }
});
const _common = require("@nestjs/common");
const _datatableservice = require("~/services/data-table.service");
const _PagedResponse = require("~/helpers/PagedResponse");
const _tablesservice = require("~/services/tables.service");
const _columnsservice = require("~/services/columns.service");
const _viewsservice = require("~/services/views.service");
const _viewcolumnsservice = require("~/services/view-columns.service");
const _viewrowcolorservice = require("~/services/view-row-color.service");
const _filtersservice = require("~/services/filters.service");
const _sortsservice = require("~/services/sorts.service");
const _hooksservice = require("~/services/hooks.service");
const _formsservice = require("~/services/forms.service");
const _mapsservice = require("~/services/maps.service");
const _commentsservice = require("~/services/comments.service");
const _syncservice = require("~/services/sync.service");
const _extensionsservice = require("~/services/extensions.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let UiGetOperations = class UiGetOperations {
    async handle(context, { req, operation }) {
        switch(operation){
            case 'nestedDataList':
                context.cache = true;
                return await this.dataTableService.nestedDataList(context, {
                    modelId: req.query.tableId,
                    rowId: req.query.rowId,
                    query: req.query,
                    viewId: req.query.viewId,
                    columnId: req.query.columnId,
                    user: req.user
                });
            case 'tableGet':
                return await this.tablesService.getTableWithAccessibleViews(context, {
                    tableId: req.query.tableId,
                    user: req.user
                });
            case 'columnsHash':
                return await this.columnsService.columnsHash(context, req.query.tableId);
            case 'viewList':
                return new _PagedResponse.PagedResponseImpl(await this.viewsService.viewList(context, {
                    tableId: req.query.tableId,
                    user: req.user
                }));
            case 'viewColumnList':
                return new _PagedResponse.PagedResponseImpl(await this.viewColumnsService.columnList(context, {
                    viewId: req.query.viewId
                }));
            case 'viewRowColorInfo':
                return await this.viewRowColorService.getByViewId({
                    context,
                    fk_view_id: req.query.viewId
                });
            case 'filterList':
                return new _PagedResponse.PagedResponseImpl(await this.filtersService.filterList(context, {
                    viewId: req.query.viewId,
                    includeAllFilters: req.query.includeAllFilters === 'true'
                }));
            case 'filterChildrenList':
                return new _PagedResponse.PagedResponseImpl(await this.filtersService.filterChildrenList(context, {
                    filterId: req.query.filterId
                }));
            case 'sortList':
                return new _PagedResponse.PagedResponseImpl(await this.sortsService.sortList(context, {
                    viewId: req.query.viewId
                }));
            case 'hookList':
                return new _PagedResponse.PagedResponseImpl(await this.hooksService.hookList(context, {
                    tableId: req.query.tableId
                }));
            case 'hookLogList':
                return new _PagedResponse.PagedResponseImpl(await this.hooksService.hookLogList(context, {
                    hookId: req.query.hookId,
                    query: req.query
                }), _extends({}, req.query, {
                    count: await this.hooksService.hookLogCount(context, {
                        hookId: req.query.hookId
                    })
                }));
            case 'hookFilterList':
                return new _PagedResponse.PagedResponseImpl(await this.filtersService.hookFilterList(context, {
                    hookId: req.query.hookId
                }));
            case 'hookSamplePayload':
                return await this.hooksService.hookSamplePayload(context, {
                    tableId: req.query.tableId,
                    operation: req.query.hookOperation,
                    version: req.query.version,
                    includeUser: req.query.includeUser === 'true',
                    event: req.query.event
                });
            case 'tableSampleData':
                return await this.hooksService.tableSampleData(context, {
                    tableId: req.query.tableId,
                    operation: req.query.hookOperation,
                    version: req.query.version,
                    includeUser: req.query.includeUser === 'true',
                    event: req.query.event
                });
            case 'formViewGet':
                return await this.formsService.formViewGet(context, {
                    formViewId: req.query.formViewId
                });
            case 'mapViewGet':
                return await this.mapsService.mapViewGet(context, {
                    mapViewId: req.query.mapViewId
                });
            case 'dataAggregate':
                context.cache = true;
                return await this.dataTableService.dataAggregate(context, {
                    query: req.query,
                    modelId: req.query.tableId,
                    viewId: req.query.viewId,
                    baseId: req.query.baseId,
                    user: req.user
                });
            case 'commentList':
                return new _PagedResponse.PagedResponseImpl(await this.commentsService.commentList(context, {
                    query: {
                        row_id: req.query.row_id,
                        fk_model_id: req.query.fk_model_id
                    }
                }));
            case 'commentCount':
                return await this.commentsService.commentsCount(context, {
                    fk_model_id: req.query.fk_model_id,
                    ids: Array.isArray(req.query.ids) ? req.query.ids : [
                        req.query.ids
                    ]
                });
            case 'dataList':
                context.cache = true;
                return await this.dataTableService.dataList(context, {
                    query: req.query,
                    modelId: req.query.tableId,
                    viewId: req.query.viewId,
                    includeSortAndFilterColumns: req.query.includeSortAndFilterColumns === 'true',
                    user: req.user
                });
            case 'linkDataList':
                context.cache = true;
                return await this.dataTableService.getLinkedDataList(context, {
                    req,
                    linkColumnId: req.query.columnId
                });
            case 'syncSourceList':
                return await this.syncService.syncSourceList(context, {
                    baseId: context.base_id,
                    sourceId: req.query.sourceId
                });
            // Extensions
            case 'extensionList':
                return new _PagedResponse.PagedResponseImpl(await this.extensionsService.extensionList(context, {
                    baseId: context.base_id
                }));
            case 'extensionRead':
                return await this.extensionsService.extensionRead(context, {
                    extensionId: req.query.extensionId
                });
        }
    }
    constructor(dataTableService, tablesService, columnsService, viewsService, viewColumnsService, viewRowColorService, filtersService, sortsService, hooksService, formsService, mapsService, commentsService, syncService, extensionsService){
        this.dataTableService = dataTableService;
        this.tablesService = tablesService;
        this.columnsService = columnsService;
        this.viewsService = viewsService;
        this.viewColumnsService = viewColumnsService;
        this.viewRowColorService = viewRowColorService;
        this.filtersService = filtersService;
        this.sortsService = sortsService;
        this.hooksService = hooksService;
        this.formsService = formsService;
        this.mapsService = mapsService;
        this.commentsService = commentsService;
        this.syncService = syncService;
        this.extensionsService = extensionsService;
        this.operations = [
            'nestedDataList',
            'tableGet',
            'columnsHash',
            'viewList',
            'viewColumnList',
            'viewRowColorInfo',
            'filterList',
            'filterChildrenList',
            'sortList',
            'hookList',
            'hookLogList',
            'hookFilterList',
            'buttonFilterList',
            'hookSamplePayload',
            'tableSampleData',
            'linkFilterList',
            'widgetFilterList',
            'formViewGet',
            'mapViewGet',
            'dataAggregate',
            'commentList',
            'commentCount',
            'dataList',
            'linkDataList',
            'syncSourceList',
            'extensionList',
            'extensionRead',
            'listViewDataList',
            'listViewDataCount'
        ];
        this.httpMethod = 'GET';
    }
};
UiGetOperations = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _datatableservice.DataTableService === "undefined" ? Object : _datatableservice.DataTableService,
        typeof _tablesservice.TablesService === "undefined" ? Object : _tablesservice.TablesService,
        typeof _columnsservice.ColumnsService === "undefined" ? Object : _columnsservice.ColumnsService,
        typeof _viewsservice.ViewsService === "undefined" ? Object : _viewsservice.ViewsService,
        typeof _viewcolumnsservice.ViewColumnsService === "undefined" ? Object : _viewcolumnsservice.ViewColumnsService,
        typeof _viewrowcolorservice.ViewRowColorService === "undefined" ? Object : _viewrowcolorservice.ViewRowColorService,
        typeof _filtersservice.FiltersService === "undefined" ? Object : _filtersservice.FiltersService,
        typeof _sortsservice.SortsService === "undefined" ? Object : _sortsservice.SortsService,
        typeof _hooksservice.HooksService === "undefined" ? Object : _hooksservice.HooksService,
        typeof _formsservice.FormsService === "undefined" ? Object : _formsservice.FormsService,
        typeof _mapsservice.MapsService === "undefined" ? Object : _mapsservice.MapsService,
        typeof _commentsservice.CommentsService === "undefined" ? Object : _commentsservice.CommentsService,
        typeof _syncservice.SyncService === "undefined" ? Object : _syncservice.SyncService,
        typeof _extensionsservice.ExtensionsService === "undefined" ? Object : _extensionsservice.ExtensionsService
    ])
], UiGetOperations);
